import {Accordion, AccordionTab} from 'primereact/accordion';
import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';
import YesNoDialog from '../components/YesNoDialog';
import CardOrderService from '../services/CardOrderService';
import CardOrderTemplateService from '../services/CardOrderTemplateService';
import CardOrderTemplateDialog from './CardOrderTemplateDialog';
import {LimitsSummaryContainer} from './LimitsSummaryContainer';

class CardOrderTemplateList extends BaseContainer {
    constructor(props) {
        super(props, new CardOrderTemplateService());
        this.cardOrderService = new CardOrderService();
        this.state = {
            element: undefined,
            loading: false,
            removeConfirmationVisible: false,
            editTemplateVisible: false,
        };
        this.hideConfirmationRemoveTemplateDialog = this.hideConfirmationRemoveTemplateDialog.bind(this);
        this.showConfirmationRemoveTemplateDialog = this.showConfirmationRemoveTemplateDialog.bind(this);
        this.hideEditTemplateDialog = this.hideEditTemplateDialog.bind(this);
        this.showEditTemplateDialog = this.showEditTemplateDialog.bind(this);
    }

    getListTitle() {
        return 'cards.listTitle';
    }

    initializeFromBackend() {}

    getContainerListName() {
        return 'order-card-template-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDraftHeader(name) {
        const headerItems = [
            {
                label: name,
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_draft_order_card_header',
            },
        ];

        return this.prepareHeader(headerItems);
    }

    hideConfirmationRemoveTemplateDialog(value) {
        const {t} = this.props;
        if (!!value) {
            this.blockUi();
            this.service
                .remove(this.state.toRemove)
                .then(() => {
                    this.setState({removeConfirmationVisible: false, toRemove: undefined}, () => {
                        this.showSuccessMessage(t('order-card.removeTemplateSuccess'));
                        if (this.props.refreshList) {
                            this.props.refreshList();
                        } else {
                            this.unblockUi();
                        }
                    });
                })
                .catch((err) => {
                    this.setState({removeConfirmationVisible: false, toRemove: undefined}, () => {
                        this.showErrorMessage(t('error.removeOrderCardError'));
                        this.unblockUi();
                    });
                });
        } else {
            this.setState({removeConfirmationVisible: false, toRemove: undefined});
        }
    }

    showConfirmationRemoveTemplateDialog(element) {
        this.setState({removeConfirmationVisible: true, toRemove: element});
    }

    showEditTemplateDialog(element) {
        this.setState({editTemplateVisible: true, element: JSON.parse(JSON.stringify(element))});
    }

    hideEditTemplateDialog(element, callback) {
        this.setState({editTemplateVisible: false, element: undefined}, () => {
            if (callback) {
                callback();
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <DivContainer colClass='container-fluid order-fuel list'>
                <DivContainer colClass='dashboard'>
                    {this.state.loading ? null : (
                        <React.Fragment>
                            <YesNoDialog
                                visible={this.state.removeConfirmationVisible}
                                header={t('order-card.removeTemplateDialogHeader')}
                                name='visible'
                                onChange={(type, x, target) => {
                                    this.hideConfirmationRemoveTemplateDialog(target.value);
                                }}
                                onHide={() => {
                                    this.hideConfirmationRemoveTemplateDialog(false);
                                }}
                                noButtonVariant='button cancel-button white'
                                yesButtonVariant='button save-button fullred'
                            >
                                {t('order-card.removeTemplateDialogConfirmation')}
                            </YesNoDialog>
                            {this.state.element !== undefined ? (
                                <CardOrderTemplateDialog
                                    key={'card-order-template-dialog'}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    element={this.state.element}
                                    onHide={(e) => this.hideEditTemplateDialog(e)}
                                    visible={!!this.state.element}
                                    viewMode={'EDIT'}
                                    afterSave={(element) =>
                                        this.hideEditTemplateDialog(element, () => {
                                            if (this.props.refreshList) {
                                                this.props.refreshList();
                                            } else {
                                                this.unblockUi();
                                            }
                                        })
                                    }
                                    className='card-order-template-dialog'
                                    containerListName={this.getContainerListName()}
                                    _isMounted={this._isMounted}
                                    template
                                    embedded
                                />
                            ) : null}
                            <form>
                                <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <Accordion multiple key='main-accordion'>
                                            {this.props.list && this.props.list.length
                                                ? this.props.list.map((element, index) => {
                                                      return (
                                                          <AccordionTab
                                                              header={this.renderDraftHeader(element.name)}
                                                              key={`card-order-template-${element.id}`}
                                                          >
                                                              <DivContainer colClass='dashboard'>
                                                                  <DivContainer colClass='col-12 dashboard-link-container'>
                                                                      <DivContainer colClass='template-list-col-padding'>
                                                                          <DivContainer colClass='row'>
                                                                              <DivContainer colClass='col-12'>
                                                                                  <DivContainer colClass='col-12 dashboard-link-container gray-background'>
                                                                                      <Card className='center-of-the-universe'>
                                                                                          <div className='row card-summary-type'>
                                                                                              <DivContainer colClass='card-summary-type-label'>
                                                                                                  <MenuItemIcon
                                                                                                      alt={t(
                                                                                                          `EcCardKind.${element.cardKind}`
                                                                                                      )}
                                                                                                      className={`max-88-icon`}
                                                                                                      iconSvg={`${
                                                                                                          element.cardKind === 'FIRM'
                                                                                                              ? 'ico_small_firm'
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE'
                                                                                                              ? 'ico_small_vehicle'
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE_PERSON'
                                                                                                              ? 'ico_small_vehicle_person'
                                                                                                              : element.cardKind ===
                                                                                                                'PERSON'
                                                                                                              ? 'ico_small_person'
                                                                                                              : ''
                                                                                                      }`}
                                                                                                  />
                                                                                              </DivContainer>
                                                                                              <DivContainer colClass='col-width-auto center-of-the-universe card-summary-type-description'>
                                                                                                  <div className='row'>
                                                                                                      <label className='font-18-600 text-left font-blue col-12 margin-bottom-8'>
                                                                                                          {element.cardKind === 'FIRM'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_company'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_vehicle'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE_PERSON'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_vehicle_person'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'PERSON'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_person'
                                                                                                                )
                                                                                                              : ''}
                                                                                                      </label>
                                                                                                      <label className='p-label text-left col-12'>
                                                                                                          {element.cardKind === 'FIRM'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_company_desc'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_vehicle_desc'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'VEHICLE_PERSON'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_vehicle_person_desc'
                                                                                                                )
                                                                                                              : element.cardKind ===
                                                                                                                'PERSON'
                                                                                                              ? t(
                                                                                                                    'order-card.cardType_person_desc'
                                                                                                                )
                                                                                                              : ''}
                                                                                                      </label>
                                                                                                  </div>
                                                                                              </DivContainer>
                                                                                          </div>
                                                                                      </Card>
                                                                                  </DivContainer>
                                                                              </DivContainer>
                                                                              <DivContainer colClass='col-12' rendered={element.monthlyAmountLimit}>
                                                                                  <label className='card-order-template-label'>
                                                                                      {`${t('order-card.monthlyAmountLimitSummary')}: `}
                                                                                      <span className='card-order-template-label-amount'>
                                                                                          {element.monthlyAmountLimit}
                                                                                      </span>
                                                                                  </label>
                                                                              </DivContainer>
                                                                              <DivContainer colClass='col-12' rendered={element.dailyVisitLimit}>
                                                                                  <label className='card-order-template-label'>
                                                                                      {`${t('cards.dailyVisitLimit')}: `}
                                                                                      <span className='card-order-template-label-amount'>
                                                                                          {element.dailyVisitLimit}
                                                                                      </span>
                                                                                  </label>
                                                                              </DivContainer>
                                                                          </DivContainer>
                                                                          <DivContainer colClass='row'>
                                                                              {(element.petrols &&
                                                                                  element.petrols.filter((p) => !!p.selected)?.length >
                                                                                      0) ||
                                                                              element.amountFuelLimit ||
                                                                              element.quantityFuelLimit ? (
                                                                                  <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                                                      <DivContainer colClass='dashboard'>
                                                                                          <DivContainer colClass='dashboard-link-container '>
                                                                                              <Card>
                                                                                                  <div className='row'>
                                                                                                      <LimitsSummaryContainer
                                                                                                          t={this.props.t}
                                                                                                          element={element}
                                                                                                          listName='petrols'
                                                                                                          effectiveActiveIndex={0}
                                                                                                      />
                                                                                                  </div>
                                                                                              </Card>
                                                                                          </DivContainer>
                                                                                      </DivContainer>
                                                                                  </DivContainer>
                                                                              ) : null}
                                                                              {(element.services &&
                                                                                  element.services.filter((p) => !!p.selected)?.length >
                                                                                      0) ||
                                                                              element.amountServiceLimit ? (
                                                                                  <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                                                      <DivContainer colClass='dashboard'>
                                                                                          <DivContainer colClass='dashboard-link-container'>
                                                                                              <Card>
                                                                                                  <div className='row'>
                                                                                                      <LimitsSummaryContainer
                                                                                                          t={this.props.t}
                                                                                                          element={element}
                                                                                                          listName='services'
                                                                                                          effectiveActiveIndex={1}
                                                                                                      />
                                                                                                  </div>
                                                                                              </Card>
                                                                                          </DivContainer>
                                                                                      </DivContainer>
                                                                                  </DivContainer>
                                                                              ) : null}
                                                                              {(element.products &&
                                                                                  element.products.filter((p) => !!p.selected)?.length >
                                                                                      0) ||
                                                                              element.amountNotFuelLimit ? (
                                                                                  <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                                                      <DivContainer colClass='dashboard'>
                                                                                          <DivContainer colClass='dashboard-link-container '>
                                                                                              <Card>
                                                                                                  <div className='row'>
                                                                                                      <LimitsSummaryContainer
                                                                                                          t={this.props.t}
                                                                                                          element={element}
                                                                                                          listName='products'
                                                                                                          effectiveActiveIndex={2}
                                                                                                      />
                                                                                                  </div>
                                                                                              </Card>
                                                                                          </DivContainer>
                                                                                      </DivContainer>
                                                                                  </DivContainer>
                                                                              ) : null}
                                                                          </DivContainer>
                                                                      </DivContainer>
                                                                      <div className='template-list-buttons '>
                                                                          <div className='left'>
                                                                              <ActionButton
                                                                                  label={t('details.delete')}
                                                                                  variant='button cancel-button red'
                                                                                  handleClick={(e) => {
                                                                                      if (e) {
                                                                                          e.preventDefault();
                                                                                      }
                                                                                      this.showConfirmationRemoveTemplateDialog(element);
                                                                                  }}
                                                                              />

                                                                              <ActionButton
                                                                                  label={t('details.editButton')}
                                                                                  variant='editButton white'
                                                                                  handleClick={(e) => {
                                                                                      if (e) {
                                                                                          e.preventDefault();
                                                                                      }
                                                                                      this.showEditTemplateDialog(element);
                                                                                  }}
                                                                              />
                                                                          </div>
                                                                          <div className='right'>
                                                                              <ActionButton
                                                                                  label={t('order-card.placeOrder')}
                                                                                  variant='editButton blue'
                                                                                  href={`${this.props.orderAgainUrl}${element.id}`}
                                                                              />
                                                                          </div>
                                                                      </div>
                                                                  </DivContainer>
                                                              </DivContainer>
                                                          </AccordionTab>
                                                      );
                                                  })
                                                : null}
                                        </Accordion>
                                    </DivContainer>
                                </DivContainer>
                            </form>
                        </React.Fragment>
                    )}
                </DivContainer>
            </DivContainer>
        );
    }

    labelHeader(item, index) {
        return (
            <div className={`pageheader-title pageheader-title-16 ${item.className}`} key={item.label + index}>
                {item.iconSvg ? <img className='card-icon' alt={item.label} src={`/images/${item.iconSvg}.svg`} /> : null}
                {item.label}
            </div>
        );
    }
}

CardOrderTemplateList.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
    cardTypePanels: false,
    detailUrl: '/#/card-details',
    orderAgainUrl: '/#/order-card-template/',
};

CardOrderTemplateList.propTypes = {
    orderAgain: PropTypes.func,
    refreshList: PropTypes.func,
};

export default withTranslation()(CardOrderTemplateList);
